import { ASPECT_RATIOS, DEFAULT_IMAGE_GALLERY_FILTERS } from 'Pods/LazyLoaded/ImageGalleryPanel/constants'

import aircraft from 'images/three_d_studio/aircraft.jpg'
import animals from 'images/three_d_studio/animals.jpg'
import car from 'images/three_d_studio/car.jpg'
import character from 'images/three_d_studio/character.jpg'
import generated1 from 'images/three_d_studio/generated-1.jpg'

// Stand-in for the community image endpoint until the backend ships. Everything
// here is deterministic so the masonry layout is stable across reloads.

const CATEGORY_VALUES = [
  'aircraft',
  'animals',
  'architectural',
  'exterior',
  'interior',
  'car',
  'character',
  'military',
  'furniture',
  'food',
  'plant',
  'science',
  'space',
  'sports',
  'vehicle',
  'watercraft',
]

// Labels are translation keys: the host resolves them with the page locale so
// the chips match the rest of the panel on locale-prefixed URLs.
export const MOCK_IMAGE_CATEGORIES = [DEFAULT_IMAGE_GALLERY_FILTERS.category, ...CATEGORY_VALUES]
  .map(value => ({ nameKey: `imageGallery.categories.${value}`, value }))

// Bundled studio assets rather than a third-party placeholder host, so the mock
// gallery never sends visitors' requests off-site. The card crops with
// `object-fit: cover`, so any photo fits every aspect ratio.
const IMAGE_SOURCES = [aircraft, animals, car, character, generated1]

const SUBJECTS = [
  'Abstract stone sculpture',
  'Coloured pencils in ceramic holders',
  'Electric aircraft on a runway',
  'Desert skyline at golden hour',
  'Fennec fox in the sand',
  'Stylised girl portrait',
  'Porcelain bunnies in eggshells',
  'Astronaut in an orange suit',
  'Red finch mid-flight',
  'Humanoid robot on concrete',
  'Rose gold diamond ring',
  'Clock tower against grey sky',
  'Toy propeller plane',
  'Rainbow butterfly swarm',
  'Tropical fish with flowing fins',
  'Vintage roadster on wet asphalt',
  'Mid-century lounge chair',
  'Neon night market alley',
  'Snowy mountain cabin',
  'Chrome espresso machine',
  'Origami crane in paper forest',
  'Sci-fi corridor with blue light',
  'Cozy reading nook',
  'Wooden sailing ship model',
]

const RATIO_KEYS = Object.keys(ASPECT_RATIOS)
const MOCK_IMAGE_COUNT = 120
export const MOCK_RESPONSE_DELAY_MS = 350

const buildImage = (index) => {
  const id = index + 1
  const ratioKey = RATIO_KEYS[(index * 7) % RATIO_KEYS.length]

  return {
    id,
    title: `${SUBJECTS[index % SUBJECTS.length]} ${Math.floor(index / SUBJECTS.length) + 1}`,
    category: CATEGORY_VALUES[index % CATEGORY_VALUES.length],
    aspectRatio: ASPECT_RATIOS[ratioKey],
    src: IMAGE_SOURCES[index % IMAGE_SOURCES.length],
  }
}

export const MOCK_IMAGES = Array.from({ length: MOCK_IMAGE_COUNT }, (_, index) => buildImage(index))

const matchesFilters = (image, { searchQuery, category }) => {
  const matchesCategory = category === DEFAULT_IMAGE_GALLERY_FILTERS.category || image.category === category
  const query = searchQuery.trim().toLowerCase()
  const matchesQuery = !query || image.title.toLowerCase().includes(query)

  return matchesCategory && matchesQuery
}

// Mirrors the { data, meta } shape of the community gallery endpoint so swapping
// in the real request later only touches the fetcher.
export const fetchMockImages = ({ page, perPage, searchQuery, category }) => new Promise((resolve) => {
  const filtered = MOCK_IMAGES.filter(image => matchesFilters(image, { searchQuery, category }))
  const start = (page - 1) * perPage

  setTimeout(() => {
    resolve({
      data: filtered.slice(start, start + perPage),
      meta: {
        currentPage: page,
        perPage,
        totalCount: filtered.length,
        totalPages: Math.ceil(filtered.length / perPage),
      },
    })
  }, MOCK_RESPONSE_DELAY_MS)
})
